<template>
    <div class="max-w-sm mx-auto px-4 pt-2 pb-4 clearfix">
        <top-nav-bar></top-nav-bar>

        <h2 class="text-center mb-8">My Account</h2>

        <input type="text" class="input mb-8" disabled v-model="username">

        <h2 class="text-center mb-6">Update Password</h2>

        <form @submit.prevent="updatePassword">
            <input type="password" class="hidden" name="phoney_password">

            <form-group name="current_password" label="Current Password" :required="true">
                <input type="password" class="input" v-model="password_current">
            </form-group>

            <form-group name="password" label="New Password" :required="true">
                <input type="password" class="input" v-model="password_new">
            </form-group>

            <form-group name="password_confirmation" label="Repeat New Password" :required="true">
                <input type="password" class="input" v-model="password_new_confirmation">
            </form-group>

            <div class="block md:inline-flex md:float-right">
                <button class="btn btn--colored__green w-full" type="submit">
                    <i class="fal fa-check"></i>
                    Save
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                password_current: null,
                password_new: null,
                password_new_confirmation: null
            }
        },

        computed: {
            username: {
                get() {
                    if (this.$store.state.account === null)
                        return null;

                    return this.$store.state.account.username
                },
                set(value) {
                    this.$store.commit('updateAccount', {
                        username: value
                    })
                }
            }
        },

        methods: {
            updatePassword() {
                this.$api().post('account/password', {
                    current_password: this.password_current,
                    password: this.password_new,
                    password_confirmation: this.password_new_confirmation
                })
                    .then(({data}) => {
                        this.$router.push('/')
                        this.$noty.success('Password updated successfully.')
                    })
                    .catch(() => {
                        this.password_new = null
                        this.password_new_confirmation = null
                    })
            }
        }
    }
</script>
